import { StyleFn } from '..'

// FIXME: should we force padding on Container ?
// Is we want to provide a Grid system it should not have padding maybe ?
const PADDING = '1rem'

const up = (value: number) => `@media (min-width:${value}px)`

export const Container: StyleFn = ({ responsive }) => {
  const { breakpoint, contentarea } = responsive

  return {
    root: {
      width: '100%',
      display: 'block',
      boxSizing: 'border-box',
      paddingLeft: PADDING,
      paddingRight: PADDING,
    },
    // "fluid until" classes for each breakpoints
    ...Object.keys(breakpoint).reduce(
      (acc, bp) => ({
        ...acc,
        [`_until-${bp}`]: {
          [up((breakpoint as any)[bp])]: {
            marginLeft: 'auto',
            marginRight: 'auto',
            maxWidth: (contentarea as any)[bp],
          },
        },
      }),
      {},
    ),
    // fixed width classes and mediaqueries
    fixed: {
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingLeft: PADDING,
      paddingRight: PADDING,
      ...Object.keys(breakpoint).reduce(
        (acc, bp) => ({
          ...acc,
          [up((breakpoint as any)[bp])]: {
            maxWidth: (contentarea as any)[bp],
          },
        }),
        {},
      ),
    },
  }
}
